import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.RodoPolicy.heading',
    defaultMessage: 'Ochrona Danych Osobowych w grupie kapitałowej TenderHut'
  }
});



// WEBPACK FOOTER //
// ./src/views/RodoPolicy/RodoPolicyView.intl.js